import {NocoDbProxy} from "./NocoDbProxy";
import {ITableListing} from "./TableInformation";
import {IProjectInformation} from "./meta/ProjectInformation";
import {ILogger} from "../log/Logger";
import {LoggerFactory} from "../log/LoggerFactory";
import {IListingReponse} from "./ListingReponse";


export class NocoDbProjectProxy {

  private static _log: ILogger = LoggerFactory.build( 'NocoDbProjectProxy' );

  public tableInformation: ITableListing;

  private static _getTargetProject( projects: IProjectInformation[], projectTitle: string ): IProjectInformation|null {

    this._log.debug( 'projects', projects );

    for( const candidate of projects ) {
      if( projectTitle === candidate.title ) {
        return candidate;
      }
    }

    NocoDbProjectProxy._log.error( "project not found; returning null" );
    return null;
  }

  public async getView<T>( table: string, view: string = 'API' ): Promise<IListingReponse<T>> {


    // https://docs.nocodb.com/0.109.7/developer-resources/rest-apis/#query-params

    const limit = 1000;

    const url = `${this.proxy.nocoDbConfig.httpServer}/api/v1/db/data/v1/${this.projectInfo.id}/${table}/views/${view}?limit=${limit}`;
    NocoDbProjectProxy._log.debug( 'url', url );

    const response = await this.proxy.get( url ) as IListingReponse<T>;

    let offset = limit;
    let isLastPage = response.pageInfo.isLastPage;
    while( !isLastPage ) {

      const pageUrl = `${url}&offset=${offset}`;
      NocoDbProjectProxy._log.debug( 'pageUrl', pageUrl );

      const pageResponse = await this.proxy.get( pageUrl ) as IListingReponse<T>;
      NocoDbProjectProxy._log.debug( 'pageResponse', pageResponse );

      isLastPage = pageResponse.pageInfo.isLastPage;

      for( const e of pageResponse.list ) {
        response.list.push( e );
      }

      offset+=limit;
    }

    NocoDbProjectProxy._log.debug( 'response', response );

    return response;
  }


  public static async build( proxy: NocoDbProxy,
                             projectTitle: string,
                             projects: IProjectInformation[] ): Promise<NocoDbProjectProxy> {

    const projectInfo = NocoDbProjectProxy._getTargetProject( projects, projectTitle );
    const answer = new NocoDbProjectProxy( proxy, projectInfo );

    // http://localhost:8080/api/v1/db/meta/projects/{projectId}/tables
    const url = `${answer.proxy.nocoDbConfig.httpServer}/api/v1/db/meta/projects/${projectInfo.id}/tables`;
    answer.tableInformation = await proxy.get( url );

    return answer;
  }


  public async readTable( tableName: string ) {

    const url = `${this.proxy.nocoDbConfig.httpServer}/api/v1/db/meta/projects/${this.projectInfo.id}/tables`;
  }


  private constructor( public proxy: NocoDbProxy,
                       public projectInfo: IProjectInformation) {
  }

}
